module.exports = __webpack_public_path__ + "img/item-6.485a1e5.png";